module.exports = __webpack_public_path__ + "static/media/price.db8fe6cc.jpg";